<form [formGroup]="recordSelectionForm" (ngSubmit)="onSave()">
    <div class="update-recommendations-section">
        <r1-compass-lib-instructions headerText="Update Recommendations">
            For preexisting Salesforce Recommendations, set the criteria for updating the existing Salesforce
            Recommendations. Records that do not match either the Update or Create New criteria, will not be sent to
            Salesforce. There must be at least one criteria element configured.
        </r1-compass-lib-instructions>
        <div class="rule-list-container">
            <div class="criteria-list">
                @for (criterionFormGroup of recordSelectionForm.controls.updateRules.controls; track $index) {
                    <r1-compass-app-generic-selection-criterion
                        [index]="$index"
                        [tables]="lifecycleRulesTables()"
                        [criterionForm]="criterionFormGroup"
                        [deletable]="$index !== 0"
                        [required]="$index === 0"
                        (deleteCriterion)="onDeleteUpdateCriterion($index)" />
                }
            </div>
            <div class="criteria-list-footer">
                <button (click)="onAddUpdateCriterion()" class="button button-black" type="button">+Add</button>
            </div>
        </div>
        <r1-compass-lib-grouping-logic-complex [groupingLogicForm]="recordSelectionForm.controls.updateGroupingLogic" />
    </div>
    <r1-compass-lib-divider />
    <div class="create-recommendations-section">
        <r1-compass-lib-instructions headerText="Create New Recommendations">
            For preexisting Salesforce Recommendations, set the criteria for creating new Salesforce Recommendations.
            Records that do not match either the Update or Create New criteria, will not be sent to Salesforce. There
            must be at least one criteria element configured.
        </r1-compass-lib-instructions>
        <div class="rule-list-container">
            <div class="criteria-list">
                @for (criterionFormGroup of recordSelectionForm.controls.creationRules.controls; track $index) {
                    <r1-compass-app-generic-selection-criterion
                        [index]="$index"
                        [tables]="lifecycleRulesTables()"
                        [criterionForm]="criterionFormGroup"
                        [deletable]="$index !== 0"
                        [required]="$index === 0"
                        (deleteCriterion)="onDeleteCreationCriterion($index)" />
                }
            </div>
            <div class="criteria-list-footer">
                <button (click)="onAddCreationCriterion()" class="button button-black" type="button">+Add</button>
            </div>
        </div>
        <r1-compass-lib-grouping-logic-complex
            [groupingLogicForm]="recordSelectionForm.controls.creationGroupingLogic" />
    </div>
    <div class="component-footer">
        <button mat-raised-button color="primary" [disabled]="disableSave()" type="submit">Save</button>
    </div>
</form>
